module.exports = __webpack_public_path__ + "img/DSC_0075.ec636be3.jpg";